/**
 * The Marketplace Banking Offer Fields.
 * @type {Array<String>}
 */
export const FIELDS = [
  'offer.derived_details.apply_link',
  'offer.derived_details.display_apy',
  'offer.derived_details.should_throttle_monetization',

  'offer.details.account_details',
  'offer.details.apy_annotation',
  'offer.details.apy',
  'offer.details.balance_to_avoid_fees',
  'offer.details.benefits',
  'offer.details.bonus_amount',
  'offer.details.bonus_details',
  'offer.details.cd_deposit_term',
  'offer.details.direct_deposit_waive',
  'offer.details.display_pages',
  'offer.details.display_status',
  'offer.details.fee_atm',
  'offer.details.fee_debit_replacement',
  'offer.details.fee_early_closure',
  'offer.details.fee_monthly',
  'offer.details.fee_overdraft',
  'offer.details.fee_paper_statements',
  'offer.details.fee_stop_payment',
  'offer.details.minimum_balance',
  'offer.details.offer_url',
  'offer.details.show_outbound_cta',

  'offer.product.details.display_name',
  'offer.product.details.display_slug',
  'offer.product.details.display_status',
  'offer.product.details.rating_stars',
  'offer.product.details.sub_product_type',

  'offer.product.institution.details.branch_count',
  'offer.product.institution.details.display_name',
  'offer.product.institution.details.display_slug',
  'offer.product.institution.details.display_status',
  'offer.product.institution.details.federally_insured',
  'offer.product.institution.details.logo_url',
  'offer.product.institution.details.nw_rating',
  'offer.product.institution.details.nw_rating_bank_experience',
  'offer.product.institution.details.nw_rating_overdraft_fee',
  'offer.product.institution.details.nw_review_url',
  'offer.product.institution.type',
  'offer.product.institution.id',

  'offer.product.institution.status',
  'offer.product.status',
  'offer.status',

  'offer.entity_type',
  'offer.product_type',
  'offer.product.entity_type',
  'offer.product.product_type',
  'offer.product.institution.entity_type',
  'offer.product.institution.product_type',

  'offer.id',
  'offer.product.id',
  'offer.institution.id',
];

/**
 * The valid sort keys.
 */
export const SORT_KEYS = {
  APY: 'apy',
  TERMS: 'terms',
};

/**
 * The various sorting strategies based on key to pass to Marketplace.
 * @see {@link https://docs.google.com/document/d/1CStR6C9rDq_6dnrrfK5wj_HYx3o4-wLO4McD1aAQyGI/edit}
 * NOTE: for CdsProductTable, these don't work; we manually sort in the provider. Keeping these here
 * in case they would work in the future.
 */
export const SORT_STRATEGIES = {
  [SORT_KEYS.APY]: [
    {
      field: 'offer.details.apy',
      order: 'desc',
    },
    {
      field: 'offer.details.cd_deposit_term',
      order: 'asc',
    },
    {
      field: 'offer.details.minimum_balance',
      order: 'asc',
    },
  ],
  [SORT_KEYS.TERMS]: [
    {
      field: 'offer.details.cd_deposit_term',
      order: 'asc',
    },
  ],
};
